import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import {
  POINTS_ROUTE,
  BENEFITS_ROUTE,
  EXCHANGE_ROUTE,
  EXCHANGE_DETAIL_ROUTE,
} from '../../../constants/Routes';

import MyPoints from './MyPoints';
import MobileDetail from './components/exchange/mobile/MobileDetail';

const PointsRouter = ({ ...props }) => {
  const { mobile } = props;
  return (
    <Switch>
      <Route exact path={POINTS_ROUTE}>
        <MyPoints path={POINTS_ROUTE} mobile={mobile} />
      </Route>
      <Route exact path={BENEFITS_ROUTE}>
        <MyPoints path={BENEFITS_ROUTE} mobile={mobile} />
      </Route>
      <Route exact path={EXCHANGE_ROUTE}>
        <MyPoints path={EXCHANGE_ROUTE} mobile={mobile} />
      </Route>
      {mobile && (
        <Route exact path={EXCHANGE_DETAIL_ROUTE}>
          <MobileDetail />
        </Route>
      )}
    </Switch>
  );
};

PointsRouter.propTypes = {
  mobile: PropTypes.bool,
};

export default PointsRouter;
